var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"movie-container"},[_c('iframe',{attrs:{"src":_vm.youtubeUrl,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }